import { Suspense } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { InstallBanner } from '@/components/pwa/InstallBanner';
import { OfflineBanner } from '@/components/pwa/OfflineBanner';
import { UpdateToast } from '@/components/pwa/UpdateToast';
import { ListSkeleton } from '@/components/ui';
import { BottomNav } from './BottomNav';

export function AppShell() {
  const { pathname } = useLocation();
  // Écrans de parcours (paiement, lecture, connexion) : sans navigation basse, comme dans le design.
  const immersive = ['/bibliotheque/lire', '/paiement', '/zakat/payer', '/connexion', '/inscription', '/admin/connexion'].some((p) => pathname.startsWith(p));
  return (
    <div className="flex min-h-dvh flex-col">
      <a href="#contenu" className="sr-only focus:not-sr-only focus:absolute focus:left-2 focus:top-2 focus:z-[70] focus:rounded-lg focus:bg-white focus:px-4 focus:py-2">
        Aller au contenu
      </a>
      <OfflineBanner />
      <main
        id="contenu"
        className={`mx-auto w-full max-w-2xl flex-1 px-4 pt-[calc(16px+env(safe-area-inset-top))] ${immersive ? 'pb-[calc(24px+env(safe-area-inset-bottom))]' : 'pb-[calc(84px+env(safe-area-inset-bottom))]'}`}
      >
        <Suspense fallback={<ListSkeleton rows={4} />}>
          <Outlet />
        </Suspense>
      </main>
      <InstallBanner />
      <UpdateToast />
      {!immersive && <BottomNav />}
      <ScrollRestoration />
    </div>
  );
}
